<template>
	<div v-if="canBuyTci || canOnlyViewTci || isUnformattedDisplay">
		<el-tooltip v-if="grossPremiumAmount || isUnformattedDisplay" placement="bottom" :open-delay="500" :disabled="!tooltip">
			<span slot="content" v-html="tooltip"></span>
			<span v-if="!isUnformattedDisplay" :class="useInsurance ? 'accent_color' : 'inactive_color'">
				{{ formatPremium(grossPremiumAmount) }}
			</span>
			<span v-else>
				{{ formatPremium(grossPremiumAmount) }}
			</span>
		</el-tooltip>
		<span v-else>
      		{{ this.$t("common.value.notAvailable") }}
    	</span>
	</div>
	<div v-else>
		<span>
			{{ this.$t("common.value.hidden") }}
		</span>
	</div>
</template>

<script>

import {formatAsMoneyAmount} from "@/common/format";

export default {
	computed: {
		grossPremiumAmount() {
			return this.params.data[this.params.grossPremiumAmountField];
		},
   		netPremiumAmount() {
			return this.params.data[this.params.netPremiumAmountField];
		},
		currency() {
			return this.params.data[this.params.currencyField];
		},
		useInsurance() {
			return this.params.data[this.params.useInsuranceField];
		},
		canBuyTci() {
		  	return this.params.canBuyTci;
		},
		canOnlyViewTci() {
			return this.params.canOnlyViewTci;
		},
		isUnformattedDisplay() {
			return this.params.unformattedDisplay;
		},
		tooltip() {
			return this.$t("investor.exchange.table.operation.bid.tciPremium.tooltip", {
				netPremium: this.formatPremium(this.netPremiumAmount, this.currency),
				grossPremium: this.formatPremium(this.grossPremiumAmount, this.currency)
			});
		},
	},
	methods: {
		formatPremium(premiumAmount, currency) {
			return formatAsMoneyAmount(premiumAmount, currency ? { currency } : null);
		}
	}

};
</script>